import type { MenuConfig } from '~typings/menu'

import permisosTributacionPg, { RESOURCE_TRIBUTACION_PG } from '@/auth/permissions/modules/tributacionPg'
import * as names from '@routes/tributacion-pg/nombres/informes'

const { informes } = permisosTributacionPg
export default [
    {
        title: 'tributacion.subopciones.reporte_103',
        route: names.ROUTE_REPORTE_103,
        resource: RESOURCE_TRIBUTACION_PG,
        action: informes.reporte103,
    },
    {
        title: 'tributacion.subopciones.reporte_104',
        route: names.ROUTE_REPORTE_104,
        resource: RESOURCE_TRIBUTACION_PG,
        action: informes.reporte104,
    },
    {
        title: 'tributacion.subopciones.reporte_107',
        route: names.ROUTE_REPORTE_107,
        resource: RESOURCE_TRIBUTACION_PG,
        action: informes.reporte107,
    },
    {
        title: 'tributacion.subopciones.reporte_tabulado_rdep',
        route: names.ROUTE_REPORTE_TABULADO_RDEP,
        resource: RESOURCE_TRIBUTACION_PG,
        action: informes.reporteTabuladoRDEP,
    },
    {
        title: 'tributacion.subopciones.reporte_control_error',
        route: names.ROUTE_REPORTE_CONTROL_ERROR_USUARIO_CONTABLE,
        resource: RESOURCE_TRIBUTACION_PG,
        action: informes.reporteControlErrorUsuarioContable,
    },
    {
        title: 'tributacion.subopciones.ats_importacion',
        route: names.ROUTE_ATS_IMPORTACION,
        resource: RESOURCE_TRIBUTACION_PG,
        action: informes.atsImportacion,
    },
] as MenuConfig[]
